import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { forgotPwdReducerApi } from "../../constants/apiConstants";
import request from "../../utils/request";
export const forgotPwd = createAsyncThunk(
  "forgotPwdReducer/forgotPwd",
  async ({ email, dispatch, setIsSuccess, setError }) => {
    try {
      const res = await request({
        url: forgotPwdReducerApi.forgotPassword,
        method: "POST",
        data: { email },
      });
      // Dispatch success response
      if (res?.httpCode === 200) {
        setIsSuccess(true);
        dispatch(forgotPwdRes(res));
      } else {
        setError("User not found");
      }

      return res;
    } catch (error) {
      console.error("rest password failed:", error);
      throw error;
    }
  }
);

const forgotPwdSlice = createSlice({
  name: "forgotPwdReducer",
  initialState: {
    resetPasswordReq: null,
    isResetPasswordLoading: false,
  },
  reducers: {
    forgotPwdRes: (state, action) => {
      state.resetPasswordReq = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPwd.pending, (state) => {
        state.isResetPasswordLoading = true;
      })
      .addCase(forgotPwd.fulfilled, (state) => {
        state.isResetPasswordLoading = false;
      })
      .addCase(forgotPwd.rejected, (state) => {
        state.isResetPasswordLoading = false;
      });
  },
});

export const { forgotPwdRes } = forgotPwdSlice.actions;
export default forgotPwdSlice.reducer;
